import { css } from 'styled-components';
export default {
    altGothicNo2: {
        regular: css `
      font-family: 'Alternate Gothic No2 D', sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
    },
    apercu: {
        light: css `
      font-family: 'Apercu', sans-serif;
      font-style: normal;
      font-weight: 300;
    `,
        lightItalic: css `
      font-family: 'Apercu', sans-serif;
      font-style: italic;
      font-weight: 300;
    `,
        bold: css `
      font-family: 'Apercu', sans-serif;
      font-style: normal;
      font-weight: 700;
    `,
    },
};
